<template>
  <div>
    <el-form ref="formQuery" label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$t('collectionCenter.region')" prop="regionId">
            <el-select
              v-model="queryForm.regionId"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('GlobalSetObj.Estado')" prop="states">
            <el-select
              v-model="queryForm.states"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              collapse-tags
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id || item.shortName"
                :label="item.shortName"
                :value="item.shortName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('navbar.siteName')" prop="siteIds">
            <el-select
              v-model="queryForm.siteIds"
              :placeholder="$t('spareNumberPoo.Only10AreDisplayed')"
              :remote-method="remoteMethodSite"
              clearable
              collapse-tags
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
              @focus="remoteMethodSite('')"
            >
              <el-option
                v-for="item in siteIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item prop="timeType">
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.timeType">
                  <el-option
                    v-for="item in timeLabel"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </template>
            <el-date-picker
              v-model="dateArr"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('operationCenter.endDate')"
              :picker-options="pickerOptions"
              :start-placeholder="$t('operationCenter.startDate')"
              popper-class="dateTimeClass"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @blur="refreshDate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
            <div>
              <el-button
                icon="el-icon-search"
                size="small"
                type="primary"
                @click="searchTable(1)"
              >
                {{ $t('GlobalSetObj.search') }}
              </el-button>
              <el-button
                icon="el-icon-refresh-left"
                size="small"
                @click="searchTable(2)"
              >
                {{ $t('operationCenter.reset') }}
              </el-button>
              <el-button size="small" @click="exportsTable()">
                {{ $t('operationCenter.exports') }}
              </el-button>
            </div>
            <div>
              <el-radio-group
                v-model="queryForm.dataType"
                size="small"
                @input="() => searchTable(1)"
              >
                <el-radio-button :label="1">{{ $t('collectionCenter.ballot') }}</el-radio-button>
                <el-radio-button :label="2">{{ $t('orderCenterCont.proportions') }}</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="sheind-table2">
      <el-table
        :cell-class-name="tableCellClassName"
        :data="tableData"
        :row-class-name="tableRowClassName"
        :span-method="arraySpanMethod"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        border
        max-height="600"
        row-key="id"
      >
        <el-table-column
          align="center"
          fixed="left"
          label=""
          type="index"
          width="1"
        >
          <template>
            <span />
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in columnList"
          :key="ind"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'State'">
              {{ scope.row.State }}
            </span>
            <span v-else>
              {{
                scope.row[item.prop] !== '' &&
                  scope.row[item.prop] !== null &&
                  scope.row[item.prop] !== undefined
                  ? scope.row[item.prop]
                  : '--'
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, ind) in currentColumnList"
          :key="ind + item.prop"
          :align="item.align"
          :label="item.label"
          :min-width="item.width"
          :prop="item.prop"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div
              :class="
                queryForm.dataType === 1 &&
                  !metricRows.includes(scope.row.Region) &&
                  !isSummaryCluster(scope.row.Cluster)
                  ? 'table-active'
                  : ''
              "
              @click="getVoteDetails(scope.row, item.prop)"
            >
              {{
                scope.row[item.prop] !== '' &&
                  scope.row[item.prop] !== null &&
                  scope.row[item.prop] !== undefined
                  ? scope.row[item.prop]
                  : '--'
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer
      :title="$t('orderCenterCont.votesDetails')"
      :visible.sync="dialogVisible"
      center
      direction="ltr"
      size="990px"
      @close="closeDrawer"
    >
      <detail
        :key="dialogVisible"
        ref="votesDetails"
        :customer-list="customerList"
        :query-data="queryData"
        :select-data="stateList"
        @call-parent-method="parentMethod"
      />
    </el-drawer>
  </div>
</template>

<script>
import {
  regionQueryList,
  reportSheinDeliveredDaily,
  reportSheinDeliveredDailyExport,
  selectState
} from '@/api/orderApi';
import { siteFuzzyQuery } from '@/api/lanshou';
import dayjs from 'dayjs';
import { goResourceTaskList } from '@/utils/goExportList.js';

export default {
  name: 'SiteTimeliness',
  components: {
    detail: () => import('./detail.vue')
  },
  data() {
    return {
      regionList: [],
      queryForm: {
        regionId: null,
        states: [],
        siteIds: [],
        beginTime: '',
        endTime: '',
        dataType: 1,
        timeType: 1
      },
      dateArr: [this.getAWeek().startDate + ' 00:00:00', this.getAWeek().endDate + ' 23:59:59'],
      timeLabel: [
        { id: 1, label: this.$t('orderCenterCont.dueTime01') },
        { id: 6, label: this.$t('newOrder.StorageTimeOutlets') }
      ],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate0 = minDate.getTime();
          if (maxDate) {
            this.choiceDate0 = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.choiceDate0).getTime();
          const minTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() - 30);
          const maxTime = new Date(choiceDateTime).setDate(new Date(choiceDateTime).getDate() + 30);
          const newDate = ((d) => {
            d.setHours(0, 0, 0, 0);
            d.setDate(d.getDate() + 1);
            return d.getTime();
          })(new Date());
          const max = newDate < maxTime ? newDate : maxTime;
          if (this.choiceDate0) {
            return time.getTime() < minTime || time.getTime() > max;
          }
          return time.getTime() > newDate;
        }
      },
      metricRows: [
        '订单数Qtd. de Pedidos',
        '已签收数Qtd. de pacotes entregues',
        '签收率Taxa de Pacotes Entregues',
        '准时签收量Qtd. de Entregas Pontuais',
        '准时签收率Taxa de Entregas Pontuais'
      ],
      columnList: [
        { label: '大区（Região）', prop: 'Region', width: 200, align: 'left' },
        { label: '州（Estado）', prop: 'State', width: 120, align: 'center' },
        { label: '网点名称（Nome do ponto）', prop: 'Cluster', width: 180, align: 'center' },
        { label: '总计（Total）', prop: 'total', width: 150, align: 'center' }
      ],
      currentColumnList: [],
      siteIdList: [],
      tableData: [],
      tableDataClone: [],
      dialogVisible: false,
      queryData: {
        moduleType: '',
        expectedTime: '',
        region: '',
        cluster: '',
        state: '',
        regionId: null,
        agingType: 9,
        timeType: 1,
        deliverStationId: null
      },
      customerList: [],
      stateList: []
    };
  },
  watch: {
    'queryForm.regionId'(newVal) {
      this.queryForm.states = [];
      if (newVal && this.regionList.length > 0) {
        const selectedRegion = this.regionList.find((item) => item.id === newVal);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          this.stateList = selectedRegion.states.map((shortName) => ({ shortName }));
        }
      } else {
        this.stateList = [];
        this.getState();
      }
    }
  },
  created() {
    this.getTableData(1);
    this.getState();
    this.getRegion();
  },
  methods: {
    isSummaryCluster(cluster) {
      return cluster && (cluster.includes('总计') || cluster.includes('Total'));
    },
    remoteMethodSite(val) {
      const value = val || '';
      siteFuzzyQuery(value).then((res) => {
        if (res.status === 'OK') {
          this.siteIdList = res.data || [];
        }
      });
    },
    getRegion() {
      regionQueryList(1).then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    parentMethod(arg) {
      this.dialogVisible = arg;
    },
    getState(name = '') {
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          name,
          countryName: 'Brazil'
        }
      };
      selectState(params, false).then((res) => {
        if (res.code === 200) {
          this.stateList = res.data.records;
        }
      });
    },
    buildQueryParams() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.agingType = 9;
      if (!queryForm.states || queryForm.states.length === 0) {
        delete queryForm.states;
      }
      return queryForm;
    },
    exportsTable() {
      if (this.dateArr && this.dateArr.length > 0) {
        this.queryForm.beginTime = this.dateArr[0];
        this.queryForm.endTime = this.dateArr[1];
      } else {
        this.queryForm.beginTime = '';
        this.queryForm.endTime = '';
        this.$message.warning(this.$t('trajectory.DatesCannotBeEmpty'));
        return;
      }
      reportSheinDeliveredDailyExport(this.buildQueryParams()).then(() => {
        goResourceTaskList();
      });
    },
    tableCellClassName({ row, columnIndex }) {
      if (columnIndex === 0 && this.metricRows.includes(row.Region)) {
        return 'choose-cell';
      }
    },
    tableRowClassName({ row }) {
      if (this.metricRows.includes(row.Region)) {
        return 'choose-row';
      }
    },
    searchTable(type) {
      if (type === 1) {
        this.getTableData(1);
      } else {
        this.queryForm = {
          regionId: null,
          states: [],
          siteIds: [],
          beginTime: '',
          endTime: '',
          dataType: 1,
          timeType: 1
        };
        this.dateArr = [
          this.getAWeek().startDate + ' 00:00:00',
          this.getAWeek().endDate + ' 23:59:59'
        ];
        this.getTableData();
      }
    },
    getTableData(val) {
      if (this.dateArr && this.dateArr.length > 0) {
        this.queryForm.beginTime = this.dateArr[0];
        this.queryForm.endTime = this.dateArr[1];
      } else {
        this.queryForm.beginTime = '';
        this.queryForm.endTime = '';
        this.$message.warning(this.$t('trajectory.DatesCannotBeEmpty'));
        return;
      }
      let loading = null;
      if (val === 1) {
        loading = this.$loading({
          fullscreen: true,
          lock: true,
          spinner: 'el-icon-loading',
          text: 'loading...',
          background: 'rgba(250, 250, 250, 0.6)'
        });
      }
      reportSheinDeliveredDaily(this.buildQueryParams())
        .then((res) => {
          if (res.code === 200) {
            this.tableData = [];
            this.currentColumnList = res.data.rows.map((item) => ({
              label: item,
              prop: item,
              width: 120,
              align: 'center'
            }));
            if (this.queryForm.dataType === 1) {
              const orders = res.data.data.orders.map((item) => ({ ...item, type: 'orders' }));
              const delivered = res.data.data.delivered.map((item) => ({ ...item, type: 'delivered' }));
              const onTime = res.data.data.onTime.map((item) => ({ ...item, type: 'onTime' }));
              this.tableData = [...orders, ...delivered, ...onTime];
            } else {
              const orders = res.data.data.orders.map((item) => ({ ...item, type: 'orders' }));
              const delivered = res.data.data.percentDelivered.map((item) => ({ ...item, type: 'delivered' }));
              const onTime = res.data.data.percentOnTime.map((item) => ({ ...item, type: 'onTime' }));
              this.tableData = [...orders, ...delivered, ...onTime];
            }
            this.tableDataClone = JSON.parse(JSON.stringify(this.tableData));
            this.tableData = this.formatData(this.tableData);
          }
        })
        .finally(() => {
          if (loading) {
            loading.close();
          }
        });
    },
    formatData(data) {
      const generateId = () => {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
          return crypto.randomUUID();
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      };
      const typeGroups = {};
      data.forEach((item) => {
        const type = item.type;
        if (!typeGroups[type]) {
          typeGroups[type] = {
            summary: [],
            regions: {}
          };
        }
        const isSummary = /Qtd. de |Taxa de /.test(item.Region);
        if (isSummary) {
          typeGroups[type].summary.push({
            id: generateId(),
            ...item
          });
          return;
        }
        const region = item.Region;
        if (!typeGroups[type].regions[region]) {
          typeGroups[type].regions[region] = {
            details: []
          };
        }
        typeGroups[type].regions[region].details.push({
          id: generateId(),
          ...item
        });
      });

      const result = [];
      Object.keys(typeGroups).forEach((type) => {
        const group = typeGroups[type];
        result.push(...group.summary);
        Object.values(group.regions).forEach((regionItem) => {
          const { details } = regionItem;
          if (details.length === 0) return;
          const parentData = {
            id: generateId(),
            ...details[0]
          };
          const childrenData = details.slice(1);
          if (childrenData.length > 0) {
            result.push({
              ...parentData,
              children: childrenData
            });
          } else {
            result.push(parentData);
          }
        });
      });
      return result;
    },
    getAWeek() {
      return {
        endDate: dayjs().format('YYYY-MM-DD'),
        startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD')
      };
    },
    refreshDate() {
      this.choiceDate0 = '';
    },
    arraySpanMethod({ row, rowIndex, columnIndex }) {
      if (!row || !this.tableData || !Array.isArray(this.tableData)) {
        return [1, 1];
      }
      if (columnIndex === 1 || columnIndex === 2) {
        const targetState = row.State;
        if (targetState === '~') {
          return [1, 1];
        }
        if (rowIndex > 0) {
          const prevRow = this.tableDataClone[rowIndex - 1];
          if (prevRow?.State === targetState) {
            return [0, 1];
          }
        }
        let rowspan = 1;
        for (let i = rowIndex + 1; i < this.tableDataClone.length; i++) {
          const currRow = this.tableDataClone[i];
          if (
            currRow?.State &&
            currRow.State === targetState &&
            currRow.State !== '~' &&
            !this.isSummaryCluster(currRow.Cluster)
          ) {
            rowspan++;
          } else {
            break;
          }
        }
        return [rowspan, 1];
      }
      return [1, 1];
    },
    getVoteDetails(row, prop) {
      if (this.queryForm.dataType === 2 || this.metricRows.includes(row.Region) || this.isSummaryCluster(row.Cluster)) {
        return;
      }
      this.dialogVisible = true;
      this.queryData = {
        moduleType: row.type,
        expectedTime: prop,
        region: row.Region,
        cluster: '',
        state: row.State?.includes('~') ? '' : row.State,
        regionId: row.RegionId,
        agingType: 9,
        timeType: this.queryForm.timeType,
        deliverStationId: row.SiteId || null
      };
      this.$nextTick(() => {
        this.$refs.votesDetails.search();
      });
    },
    closeDrawer() {
      this.dialogVisible = false;
      this.$refs.votesDetails.resetForm();
    }
  }
};
</script>

<style>
.sheind-table2 .el-table__cell { background: #fff; }
.sheind-table2 .el-table {
  color: #333;
  font-size: 16px;
}

.sheind-table2 .el-table thead {
  color: #fff;
}

.sheind-table2 .el-table th.el-table__cell {
  background-color: #000;
}

.sheind-table2 .choose-row {
  background-color: #1caa22;
}

.sheind-table2 .choose-cell {
  font-weight: bold;
}

.sheind-table2 .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: transparent !important;
}

.dateTimeClass.el-picker-panel .el-picker-panel__footer .el-button--text {
  display: none;
}

.table-active {
  color: #00A551;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold !important;
  text-align: left;
  padding-left: 0;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}
</style>
